// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-form {
  height: 100%;
  overflow-y: auto;
}
.fi-form .mat-mdc-tab-group {
  height: 100%;
}
.fi-form .mat-mdc-tab-group .mat-mdc-tab-body-wrapper {
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./Source/app/fi-form/fi-form-edit/fi-form-edit.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,gBAAA;AACJ;AAAI;EACI,YAAA;AAER;AADQ;EACI,YAAA;AAGZ","sourcesContent":[".fi-form {\r\n    height: 100%;\r\n    overflow-y: auto;\r\n    .mat-mdc-tab-group {\r\n        height: 100%;\r\n        .mat-mdc-tab-body-wrapper {\r\n            height: 100%;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
